import React from 'react';
import classnames from 'classnames';
import { RenderOnlyFor, PageNavigation, useNeuroMessages } from '@ignitesales/neuro-application';
import ReactSVG from 'react-svg';

const Header = ({ className, isAppLoading }) => {
  const cssBEM = 'header';
  const classes = classnames(cssBEM, className);
  const messageContext = useNeuroMessages();
  const url = messageContext.getMessage('header.logo.url');

  return <header className={ classes }>
    <div className="header__logo float-left">
      <a href={ url } target="_blank">
        <ReactSVG src="/classpath/assets/images/regions-logo-edit.svg"/>
      </a>
    </div>
    {!isAppLoading &&
    <RenderOnlyFor forSummaryPage={true}>
      <PageNavigation
        className='summary'
        hideNext={true}
        hidePrevious={true}
      />
    </RenderOnlyFor>
    }
  </header>;
};

export default Header;
